
<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="header">
                <span *ngIf="!userRoleId" class="modal-header-title">{{ 'Создать новую роль' | translate }}</span>
                <span *ngIf="userRoleId" class="modal-header-title">{{ 'Редактировать роль' | translate }}</span>
    
                <!-- tools -->
                <div class="tools">
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>
            </div>

            <!-- form -->
            <div class="card-body role-name">
                <div class="row">
                    <div class="col-12">
                        <form class="form" [formGroup]="nameForm" autocomplete="off">
                            <ff-input-lang
                                class="ff-group" 
                                label="{{ 'USERS.USERS_ROLES.NAME_ROLE' | translate }}"
                                placeHolder="{{ 'USERS.USERS_ROLES.NAME_ROLE_ALL_LANGUAGE' | translate }}"
                                fieldId="name" 
                                fieldName="name"
                                fieldType="text" 
                                [clearField]="ffInputLangParams.name.clearField"
                                [inputValue]="roleName"
                                (changeValue)="eventFnFF('name', $event)">
                            </ff-input-lang>
                        </form>
                    </div>
                </div>

                <!-- navigate -->
                <div class="nav-panel">
                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <!-- Sections and Buttons -->
                            <a class="nav-link active" id="nav-sections-and-buttons-tab" data-toggle="tab" href="#nav-sections-and-buttons" role="tab" aria-controls="nav-sections-and-buttons" aria-selected="true"> Разделы и кнопки </a>
                            <!-- Product Information -->
                            <button class="nav-link" id="nav-products-tab" data-toggle="tab" href="#nav-products" role="tab" aria-controls="nav-products" aria-selected="true" [disabled]="!userRoleId"> Информация о товарах </button>
                            <!-- Products -->
                            <button class="nav-link" id="nav-info-abut-product-tab"  data-toggle="tab" href="#nav-info-abut-product" role="tab" aria-controls="nav-info-abut-product" aria-selected="true" [disabled]="!userRoleId"> Товары </button>
                        </div>
                    </nav>
                </div>

                <!-- nav content -->
                <div class="tab-content">

                    <!--  sections and buttons -->
                    <div class="tab-pane fade show active" id="nav-sections-and-buttons" role="tabpanel" aria-labelledby="nav-sections-and-buttons">
                        <!-- <app-user-org-roles-actions (setRoleName)="setDataInForm($event)" (applyFormData)="onActionCreate($event)"></app-user-org-roles-actions> -->
                        <app-user-org-roles-actions></app-user-org-roles-actions>

                        <!-- buttons -->
                        <div class="footer-btn">
                            
                            <div class="btn-inner">
                                <!-- btn close -->
                                <button type="button" class="btn btn-light btn-sm btn-close" (click)="close()">
                                    Закрыть
                                </button>
    
                                <!-- btn create -->
                                <button *ngIf="!userRoleId" type="button" class="btn btn-primary btn-sm"  (click)="onActionCreate('create')" [disabled]="form.invalid || !ffInputLang.valid || !checkValidation"> {{ 'SAVE'| translate}} </button>
                                <button *ngIf="userRoleId" type="button" class="btn btn-primary btn-sm"  (click)="onActionCreate('update')" [disabled]="form.invalid || !ffInputLang.valid || !checkValidation"> {{ 'SAVE'| translate}} </button>
                            </div>
                        </div>
                    </div>

                    <!-- accsess-to-attributes -->
                    <div class="tab-pane fade show" id="nav-products" role="tabpanel" aria-labelledby="nav-products-tab">

                        <app-accsess-to-attributes [userRoleId]="userRoleId"></app-accsess-to-attributes>

                        <!-- button -->
                        <div class="footer-btn">
                            <!-- btn close -->
                            <button type="button" class="btn btn-light btn-sm btn-close" (click)="close()">
                                Закрыть
                            </button>
                        </div>
                    </div>

                    <!-- conditions-filter -->
                    <div class="tab-pane fade show" id="nav-info-abut-product" role="tabpanel" aria-labelledby="nav-info-abut-product">

                        <app-conditions-filter [filterData]="'products'" (applyFormData)="applyFilterData($event)" (resetFormData)="resetFilter()"></app-conditions-filter>

                        <!-- button -->
                        <div class="footer-btn">
                            <!-- btn close -->
                            <button type="button" class="btn btn-light btn-sm btn-close" (click)="close()">
                                Закрыть
                            </button>
                        </div>
                    </div>


                    <!--  -->
                    <div class="tab-pane fade show" id="nav-history" role="tabpanel" aria-labelledby="nav-history">

                    </div>

                </div>


                <!-- <div class="footer-btn">
                    <button *ngIf="!orgRoleId" type="button" class="btn btn-primary btn-sm"  (click)="onActionCreate()" [disabled]="form.invalid || !ffInputLang.valid"> {{ 'SAVE'| translate}} </button>
                </div> -->

                <!-- <div id="stepper1" class="bs-stepper"> -->

                    <!-- <div class="bs-stepper-header">
                        <div class="step" data-target="#test-l-1">
                            <button class="step-trigger" [disabled]="form.invalid || !ffInputLang.valid">
                                <span class="bs-stepper-label">{{ 'MODULES_AND_PERMISSIONS' | translate }}</span>
                            </button>
                        </div> -->
                        <!-- <div class="line"></div>
                        <div class="step" data-target="#test-l-2">
                            <button class="step-trigger">
                                <span class="bs-stepper-label">{{ 'ACCESS_TO_PRODUCTS' | translate }}</span>
                            </button>
                        </div> -->
                        <!-- <div class="line"></div>
                        <div class="step" data-target="#test-l-2">
                            <button class="step-trigger" [disabled]="!roleId || form.invalid || !ffInputLang.valid">
                                <span class="bs-stepper-label">{{ 'ACCESS_TO_ATTRIBUTES' | translate }}</span>
                            </button>
                        </div>

                        <div class="line"></div>
                        <div class="step" data-target="#test-l-3">
                            <button class="step-trigger" [disabled]="!roleId  || form.invalid || !ffInputLang.valid">
                                <span class="bs-stepper-label">Доступ к категориям товаров</span>
                            </button>
                        </div>
                    </div>

                    <div class="bs-stepper-content">

                        <div id="test-l-1" class="content">

                            <div class="wrapper"> -->
                                <!-- <app-user-org-roles-actions [orgRoleId]="orgRoleId"  (setRoleName)="setDataInForm($event)" (applyFormData)="onActionCreate($event)"></app-user-org-roles-actions> -->
                                <!-- <app-user-org-roles-actions (setRoleName)="setDataInForm($event)" (applyFormData)="onActionCreate($event)"></app-user-org-roles-actions>
                            </div>

                            

                            <div class="row">
                                <div class="col-12">
                                    <div class="stepper-btn-box  d-flex justify-content-end">
                                        <button *ngIf="!orgRoleId" type="button" class="btn btn-primary btn-sm"  (click)="onActionCreate()" (click)="activeModal.dismiss(false)" [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
                                        <button *ngIf="orgRoleId" (click)="nextStep()" [disabled]="form.invalid || !ffInputLang.valid" class="btn btn-primary btn-sm">{{ 'PROCEED' | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <!-- <div id="test-l-2" class="content">

                            <app-conditions-filter [filterData]="'settings'"></app-conditions-filter>
                            <app-products-list [dataPerAndMod]="'settings'"></app-products-list>

                            <div class="stepper-btn-box">
                                <button (click)="prevStep()" class="btn btn-light btn-sm prev-step">{{ 'BACK' | translate }}</button>
                                <button (click)="nextStep()" class="btn btn-primary btn-sm">{{ 'PROCEED' | translate }}</button>
                            </div>
                        </div> -->

                        <!-- <div id="test-l-2" class="content">

                            <div class="wrapper">
                                <app-accsess-to-attributes *ngIf="roleId" [roleId]="roleId"></app-accsess-to-attributes>
                            </div> -->

                            

                            <!-- <form class="form" #f="ngForm" [formGroup]="attributeForm" autocomplete="off">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate}}:</label>
                                            <ng-select id="attribute_id" class="custom"
                                                clearAllText="{{ 'CLEAN' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="id"
                                                formControlName="attribute_id"
                                                [multiple]="true"
                                                [items]="attributes"
                                                [closeOnSelect]="false"
                                                groupBy="attribute_group_name"
                                                [selectOnTab]="true">
                                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                    let-index="index">
                                                    <input id="item-{{index}}"
                                                    type="checkbox"
                                                        [checked]="item$.selected" />&nbsp;
                                                    <span>{{item.name}}</span>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                            </form> -->
                            <!-- <div class="row">
                                <div class="col-12">
                                    <div class="stepper-btn-box  d-flex justify-content-end">
                                        <button (click)="prevStep()" [disabled]="form.invalid || !ffInputLang.valid" class="btn btn-light btn-sm prev-step">{{ 'BACK' | translate }}</button>
                                        <button (click)="nextStep()" [disabled]="form.invalid || !ffInputLang.valid" class="btn btn-primary btn-sm">{{ 'PROCEED' | translate }}</button>
                                    </div>
                                </div>
                            </div> -->
                        <!-- </div> -->

                        <!-- <div id="test-l-3" class="content"> -->

                            <!-- <div class="wrapper">
                                <app-access-to-categories *ngIf="roleId" [roleId]="roleId"></app-access-to-categories>
                            </div> -->

                            

                            <!-- <div class="stepper-btn-box">
                                <button (click)="prevStep()" class="btn btn-light btn-sm prev-step">{{ 'BACK' |
                                    translate }}</button>
                            </div> -->
                            <!-- <div class="row">
                                <div class="col-12">
                                    <div class="stepper-btn-box  d-flex justify-content-end">
                                        <button (click)="prevStep()" [disabled]="form.invalid || !ffInputLang.valid" class="btn btn-light btn-sm prev-step">{{ 'BACK' | translate }}</button>
                                        <button *ngIf="!orgRoleId" (click)="activeModal.dismiss(false)" type="button" class="btn btn-primary btn-sm"  (click)="onCreate()"  [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
                                        <button *ngIf="orgRoleId" (click)="activeModal.dismiss(false)" type="button" class="btn btn-primary btn-sm" (click)="onUpdate()" [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div> -->

                <!-- <div class="card-footer">
                <div class="row">
                    <div class="col-12">
                        <div class="tools d-flex flex-end btn-pos">
                            <button (click)="prevStep()" class="btn btn-light btn-sm prev-step mr-1">{{ 'BACK' | translate }}</button>
                            <button (click)="nextStep()" class="btn btn-primary btn-sm mr-1">{{ 'PROCEED' | translate }}</button>    
                        </div>
                    </div>
                </div>
            </div> -->

            </div>
        </div>